import { Stack } from "@mui/system";
import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import TemplatesFilter from "./TemplatesFilter";
import { Link as RouterLink } from "react-router-dom";
import { selectUserData } from "../../../../../features/userSlice";
import { useSelector } from "react-redux";
import { CheckPermissionsDesign } from "../../../../../pages/AssetManagement/Design/CheckPermission/CheckDesignPermissions";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import store from "../../../../../store";
import { setSelectedTemplate } from "../../../../../features/templateSlice";

function TemplatesFilterCard() {
  const { designTemplatesData, selectedTemplate } = useSelector(
    (state: any) => state.template
  );
  const templates = designTemplatesData?.map((template: any) => template?.name);

  const clearSelectedTemplate = () => {
    store.dispatch(setSelectedTemplate(null)); // Clear the selected template
  };

  const userData = useSelector(selectUserData);
  const hasCreateTemplateNotesPermission = CheckPermissionsDesign(
    userData?.data?.products,
    "create_template"
  );
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    store.dispatch(setSelectedTemplate(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Stack
        flexDirection={"row"}
        justifyContent={"start"}
        gap={2}
        sx={{ padding: "16px 16px 0px 16px" }}
      >
        <Autocomplete
          sx={{ width: "300px" }}
          data-tracker="147"
          options={templates ? templates : []}
          value={selectedTemplate}
          onChange={(_, newValue: any) => {
            store.dispatch(setSelectedTemplate(newValue));

            // Preserve existing search params while updating 'selectedTemplate'
            setSearchParams((prevParams) => {
              const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
              if (newValue) {
                updatedParams.search = newValue; // Set new value
              } else {
                delete updatedParams.search; // Remove from URL if cleared
              }
              updatedParams.page = "0";

              return updatedParams;
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Template Name"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "12px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
        />
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          <TemplatesFilter
            designTemplatesData={designTemplatesData}
            clearSelectedTemplate={clearSelectedTemplate}
          />
          {hasCreateTemplateNotesPermission ? (
            <>
              <RouterLink
                to={`create_new_template?${(() => {
                  const params = new URLSearchParams(searchParams);
                  params.set("page", "0");
                  return params.toString();
                })()}`}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  data-tracker="148"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  <Stack flexDirection={"row"} gap={1}>
                    Create Template <AddIcon fontSize="small" />
                  </Stack>
                </Button>
              </RouterLink>
            </>
          ) : (
            <>
              <Button
                variant="contained"
                disabled
                data-tracker="148"
                sx={{ whiteSpace: "nowrap" }}
              >
                <Stack flexDirection={"row"} gap={1}>
                  Create Template <AddIcon fontSize="small" />
                </Stack>
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </>
  );
}
export default TemplatesFilterCard;
